import { FieldStateV3, FormContext, FormStateV3 } from '../../../../../commonv3/states/form/FormStateV3';
import { RawHtml } from '../../../../../commonv3/types/block';
import { StringValidators } from '../../../../../commonv3/states/form/validators';

type Comment = {
  content: RawHtml;
  review_complete: boolean;
};

export class SubmissionCommentFormState extends FormStateV3<Comment> {
  constructor() {
    super({
      content: new FieldStateV3<RawHtml>([StringValidators.required()]),
      review_complete: new FieldStateV3<boolean>(),
    });
  }
  init(): SubmissionCommentFormState {
    const defaultValue = {
      content: '',
      review_complete: false,
    };
    this._init('submission_comment', new FormContext(), defaultValue);
    return this;
  }
}
